module.exports = __webpack_public_path__ + "img/lari-sign.a80423b8.svg";